// @ts-strict-ignore
import {LookupTableDefinition} from 'apps/lexicon/src/models';
import {reporter} from 'common/report/error-reporting';
import {getProjectId, getWorkspaceId} from 'common/report/util';
import {objToQueryString} from 'common/util';
import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint({entity, searchParams}: {entity?: string; searchParams?: Record<string, string>} = {}): string {
  return (
    appApiUrl(`data-definitions/lookup-tables` + (entity ? `/${entity}` : ``), {
      projectId: getProjectId(),
      workspaceId: getWorkspaceId(),
    }) + (searchParams ? `?${objToQueryString(searchParams)}` : ``)
  );
}

export function getById(id: string) {
  return apiClient.get<LookupTableDefinition>(buildEndpoint(), {'data-group-id': id});
}

export async function updateLookupTableDefinition(
  dataGroupId: string,
  propsToUpdate: Partial<LookupTableDefinition>,
): Promise<void> {
  try {
    await apiClient.patch(buildEndpoint(), {...propsToUpdate, 'data-group-id': dataGroupId});
  } catch (error) {
    reporter.error(error, `updateLookupTableDefinition error`, {'data-group-id': dataGroupId, propsToUpdate});
    throw error;
  }
}

export async function deleteLookupTableDefinitions(dataGroupIds: string[]): Promise<void> {
  try {
    await apiClient.delete(buildEndpoint(), {body: JSON.stringify({'data-group-ids': dataGroupIds})});
  } catch (error) {
    reporter.error(error, `deleteLookupTableDefinition error`, {'data-group-ids': dataGroupIds});
    throw error;
  }
}

export function getLookupTableDownloadUrl(dataGroupId: string): Promise<string> {
  return apiClient.get(buildEndpoint({entity: `download-url`, searchParams: {'data-group-id': dataGroupId}}));
}

export const lookupTablesClient: ApiResourceClient<TODO> = {
  index() {
    return apiClient.hydratedGet(buildEndpoint());
  },

  get(dataGroupId: string) {
    return apiClient.hydratedGet(buildEndpoint(), undefined, {body: JSON.stringify({'data-group-id': dataGroupId})});
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
